module.exports = __webpack_public_path__ + "static/media/bestPlacetowork.2a68332c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bestPlacetowork.webp
// module id = 312
// module chunks = 0